import {
  Heading,
  Box,
  Flex,
  Link,
  Text,
  Button,
  Spacer,
  Image,
} from "@chakra-ui/react";

import { AiFillHtml5 } from "react-icons/ai";
import { SiCss3 } from "react-icons/si";
import { DiJavascript1 } from "react-icons/di";

import React from "react";

const SinglePro = ({ img, details, head, deploy, github }) => {
  return (
    <Box boxShadow="md">
      <Heading textAlign={"center"} mt="-3rem" fontSize={"3xl"}>
        {head}
      </Heading>
      <Flex>
        <Box w="300%" border="4px solid black" overflow={"hidden"}>
          <Image
            w="80%"
            h="100%"
            m={"auto"}
            src={img}
            _hover={{ transform: "scale(1.2)" }}
          />
        </Box>
        <Box
          border="2px solid orangered"
          background={"rgb(239, 202, 188)"}
          h="65%"
          m="auto"
          marginLeft={"-25%"}
          p="1rem"
          w="180%"
          zIndex="2"
          color="black"
        >
          <Heading fontSize={"2xl"} background={"rgb(239, 202, 188)"} mb="2rem">
            {head}
          </Heading>
          <Text background={"rgb(239, 202, 188)"}>{details}</Text>
          <Flex background={"rgb(239, 202, 188)"} w="60%" m="auto" mt="2rem">
            <AiFillHtml5 size="40" color={"#f27130"} />
            <Spacer />
            <SiCss3 size="40" color="#309ef2" />
            <Spacer />
            <DiJavascript1 size="40" color="#eba134" />
          </Flex>
          <br />
          <Link href={deploy}>
            <Button
              background="orangered"
              color="white"
              _hover={{
                background: "white",
                color: "orangered",
                border: "1px solid orangered",
              }}
            >
              See Live
            </Button>
          </Link>
          <Link href={github}>
            <Button
              background="orangered"
              color="white"
              ml="1rem"
              _hover={{
                background: "white",
                color: "orangered",
                border: "1px solid orangered",
              }}
            >
              See Code
            </Button>
          </Link>
        </Box>
      </Flex>
      <br />
      <Box w="100%" m="auto" border="1px solid orangered"></Box>
    </Box>
  );
};

export default SinglePro;
